export default __webpack_public_path__ + "static/media/iconeAgua2.66c96e5e.png";